






































































































































































































import {
  BForm,
  BButton,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BSpinner,
  BFormSelect,
  BModal,
  BCardText,
  BCardTitle,
  BNavItem,
  BFormSelectOption,
  BCard,
  BFormDatepicker,
  BFormTimepicker,
  BMedia,
  BFormTextarea
} from "bootstrap-vue";
import { Component, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import appSettings from "@/appSettings";
import { PaginatedList } from "@/api/models/common/paginatedList";
import { PtfBeneficiaireIntervenant } from "@/api/models/ptfBeneficiaire/Intervenant";
import { PtfBeneficiaireMeeting } from "@/api/models/ptfBeneficiaire/Meeting";
import AppTimeline from "@/@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@/@core/components/app-timeline/AppTimelineItem.vue";
import { PtfBeneficiaireMeetingGrouped } from "@/api/models/ptfBeneficiaire/MeetingGrouped";
import { __values } from "tslib";

@Component({
  components: {
    BRow,
    BCol,
    BButton,
    BFormInput,
    BSpinner,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BModal,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    BCardText,
    BCardTitle,
    BNavItem,
    BFormSelectOption,
    BCard,
    BFormDatepicker,
    BFormTimepicker,
    BFormTextarea,
    AppTimeline,
    AppTimelineItem,
    BMedia
  },
})
export default class DetailsIntervenant extends Vue {
  tenantId = appSettings.getTenantId();
	tenantName = appSettings.getTenantName().toLowerCase();
  intervenant: PtfBeneficiaireIntervenant | null = null;
  mainLoading = false;
  loadingRdv = false;
  loadingSave = false;
  required = required;
  timeout: any = null;
  refreshIndex = 0


  dateDebut: string | null = this.getCurrentDate();
  dateFin: string | null = null

  listMeetings: PtfBeneficiaireMeetingGrouped[] = []

  // Données pour la modale d'indisponibilité
  indisponibilite = {
    dateDebut: this.getCurrentDate(),
    heureDebut: '08:00',
    dateFin: this.getCurrentDate(),
    heureFin: '18:00',
    text: 'Indisponibilité créée suite à '
  }

  async created() {
    await this.loadIntervenant()
  }

  get getCountMeetingCkecked() {
    if (!Array.isArray(this.listMeetings)) return 0;

    return this.listMeetings.reduce((total, group) => {
      const countInGroup = (group.meetings || []).filter(m => (!m.initialNotified && m.annule === true)).length;
      return total + countInGroup;
    }, 0);
  }

  getCurrentDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  // get getCountMeetingCkecked() {
  //   const checkboxes = document.querySelectorAll('.checkbox-meeting:checked');
  //   return checkboxes.length;
  // }

  get getTotalCountMeeting() {
    if (!Array.isArray(this.listMeetings)) return 0;

    return this.listMeetings.reduce((total, group) => {
      const countInGroup = (group.meetings || []).filter(m => !m.initialNotified).length;
      return total + countInGroup;
    }, 0);
  }

  getHeure(dateTime: any) {
    var date = new Date(dateTime);
    return date.toLocaleTimeString('fr-FR', {hour: '2-digit', minute:'2-digit'}).replace(':', 'h');
  }

  getJour(dateTime: any) {
    var date = new Date(dateTime);
    return date.toLocaleString('fr-FR', { day: '2-digit' });
  }
  
  getWeekDay(dateTime: any) {
    var date = new Date(dateTime);
    var weekDay = date.toLocaleString('fr-FR', { weekday: 'long' })
    return weekDay[0].toUpperCase() + weekDay.slice(1)
  }

  getMois(dateTime: any) {
    var date = new Date(dateTime);
    return date.toLocaleString('fr-FR', { month: 'long' });
  }

  checkAllDay(value: any, date: any) {
    var meetings = this.listMeetings.find(x => x.date == date)
    if (!meetings?.meetings) return;

    // Ne met à jour que les meetings qui ne sont pas initialement notifiés
    meetings.meetings.forEach(meeting => {
      if (!(meeting.initialNotified === true && meeting.annule === true)) {
        meeting.annule = value;
      }
    });
    this.refreshIndex++
  }

  isDayChecked(date: string): boolean {
    const meetings = this.listMeetings.find(x => x.date === date);
    if (!meetings?.meetings?.length) return false;
    
    // Vérifie si tous les meetings non-initialement notifiés sont cochés
    return meetings.meetings
      .filter(m => !(m.initialNotified === true && m.annule === true))
      .every(m => m.annule === true);
  }
  
  async cancelMeetings() {
    const meetingsToCancel = this.listMeetings
      .flatMap(group => (group.meetings || []))
      .filter(meeting => !meeting.initialNotified && meeting.annule === true);
    
    const meetingCount = meetingsToCancel.length;
    
    this.$bvModal
      .msgBoxConfirm(`Êtes-vous sûr de vouloir annuler ${meetingCount} rendez-vous ?`, {
        title: "Confirmation d'annulation",
        size: "sm",
        okVariant: "warning",
        okTitle: "Oui, annuler",
        cancelTitle: "Non",
        cancelVariant: "outline-secondary",
        hideHeaderClose: false,
        centered: true,
      })
      .then(async (value) => {
        if (value === true) {
          await this.confirmCancelMeetings();
        }
      });
  }

  async confirmCancelMeetings() {
    this.loadingSave = true;
    const meetingsFormatted = this.listMeetings
      .flatMap(group => (group.meetings || []))
      .filter(meeting => !meeting.initialNotified && meeting.annule === true)
      .map(meeting => meeting.id);
      
    await this.$http.ptfBeneficiaire.meetings
      .cancelMeetings(meetingsFormatted)
      .then(
        async (response: any) => {
          await this.loadListMeetings({
            dateDebut: this.dateDebut,
            dateFin: this.dateFin,
            intervenantId: this.$route.params.id
          })
          
          this.loadingSave = false;

          // Proposer de créer une indisponibilité
          this.$bvModal.show('modal-create-indisponibilite');
        },
        (error: any) => {
          this.loadingSave = false;
          errorAlert.fire({
            title: "Oops",
            text: error.message,
          });
        }
      );
  }

 
  async loadIntervenant() {
    this.mainLoading = true;
    await this.$http.ptfBeneficiaire.meetings
      .getIntervenantById(this.$route.params.id)
      .then((res: PtfBeneficiaireIntervenant) => {
        this.intervenant = res;
        this.mainLoading = false;
      });
  }

  async searchMeetings() {
    this.loadingRdv = true
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.loadListMeetings({
        dateDebut: this.dateDebut,
        dateFin: this.dateFin,
        intervenantId: this.$route.params.id
      })
    }, 1000);
  }

  async loadListMeetings(params: any) {    
    await this.$http.ptfBeneficiaire.meetings
      .listMeetingsByIntervenantId(
        params?.intervenantId,
        params?.dateDebut,
        params?.dateFin
      )
      .then((response: PtfBeneficiaireMeetingGrouped[]) => {
        this.listMeetings = response.map(group => ({
          ...group,
          allInitiallyNotified: group.meetings?.every(meeting => meeting.annule === true) ?? false,
          meetings: group.meetings?.map(meeting => ({
            ...meeting,
            initialNotified: meeting.annule
          }))
        }));
        this.loadingRdv = false
      }
    );
  }
  
  // async changeStatus(intervenant: Entreprise) {
  //   intervenant.status = this.newStatus;
  //   await this.$http.myressif.entreprises
  //     .update(this.$route.params.id, intervenant)
  //     .then(
  //       async (response: any) => {
  //         successAlert.fire({
  //           title: "Modification du statut",
  //           text: "Modification effectuée avec succès",
  //         });
  //       },
  //       (error: any) => {
  //         errorAlert.fire({
  //           title: "Oops",
  //           text: error.message,
  //         });
  //       }
  //     );
  //     await this.loadIntervenant()
  // }

  goToList() {
    this.$router.push({ name: "manage-meetings" });
  }

  async createIndisponibilite() {
    const indisponibiliteData = {
      IntervenantId: this.intervenant?.idMeetingExterne,
      StartDateTime: `${this.indisponibilite.dateDebut}T${this.indisponibilite.heureDebut}:00`,
      EndDateTime: `${this.indisponibilite.dateFin}T${this.indisponibilite.heureFin}:00`,
      Text: this.indisponibilite.text
    };
    
    try {
      await this.$http.ptfBeneficiaire.meetings.createIndisponibilite(indisponibiliteData);
      successAlert.fire({
        title: "Indisponibilité créée",
        text: "L'indisponibilité a été créée avec succès",
      });
    } catch (error: any) {
      errorAlert.fire({
        title: "Erreur",
        text: "Impossible de créer l'indisponibilité",
      });
    }
    
    this.resetIndisponibiliteForm();
  }

  closeIndisponibiliteModal() {
    this.resetIndisponibiliteForm();
  }

  resetIndisponibiliteForm() {
    this.indisponibilite = {
      dateDebut: this.getCurrentDate(),
      heureDebut: '08:00',
      dateFin: this.getCurrentDate(),
      heureFin: '18:00',
      text: 'Indisponibilité créée suite à annulation de rendez-vous'
    };
  }
}
